<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Members</template>
        </page-header>
        <pro-table
            :resource="resource"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="100"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="first"
            direction="ASC"
            delete-label="first last"
            :actions="actions"
            :permissions="true"
        ></pro-table>
        <SmsModal :to="sendTo" v-if="showSMSModal" model="Member" :id="rowID" @close="showSMSModal = false" @sent="showSMSModal = false" :meta="SMSMeta" />
    </div>
</template>

<script>
    import DataTableSetup from '../../mixins/DataTableSetup';
    import SmsModal from '@/components/modals/SmsModal'
    import axios from 'axios';

    export default {
        name: "Members",
        mixins: [ DataTableSetup ],
        components: {
            SmsModal
        },
        data: function() {
            return {
                resource: 'members',
                numberOfFilters: 5,
                pageActions: {},
                fields: [
                    {
                        name: 'Name',
                        column: 'full_name',
                        route: '/members/{id}/view',
                        linked: true,
                        sortCol: 'last'
                    },
                    {
                        name: 'DOB',
                        column: 'date_of_birth',
                        sortCol: 'date_of_birth',
                    },
                    {
                        name: 'Age',
                        column: 'age',
                    },
                    {
                        name: 'Member ID',
                        column: 'member_id_display',
                        sortCol: 'member_id'
                    },
                    {
                        name: 'Location',
                        column: 'suburb',
                        sortCol: 'suburb',
                    },
                    {
                        name: 'Type',
                        column: 'type.name',
                    },
                    {
                        name: 'Associates',
                        column: 'relationships',
                        align: 'center',
                        route: '/members/{id}/view#associates',
                        linked: true,
                    },
                    {
                        name: 'Approved',
                        column: 'applications.approved',
                        align: 'center'
                    },
                    {
                        name: 'Pending',
                        column: 'applications.pending',
                        align: 'center'
                    },
                    {
                        name: 'Incomplete',
                        column: 'applications.incomplete',
                        align: 'center'
                    },
                    {
                        name: 'Completed',
                        column: 'applications.completed',
                        align: 'center'
                    },
                    {
                        name: 'Last Logged In',
                        column: 'last_login',
                        align: 'center',
                        sortCol: 'last_login'
                    },
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'SMS', method: 'sendSMS', icon: 'paper-plane',  type: 'method', tooltip: 'Send SMS', permissions: 'members.edit' },
                        { label: 'View', link: 'view', icon: 'eye',  type: 'router-link', tooltip: 'View', permissions: 'members.show' },
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'members.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'members.destroy' },
                    ]
                },
                showSMSModal: false,
                sendTo: {},
                rowID: null,
                SMSMeta: null
            }
        },
        methods: {
            sendSMS(payload){
                this.sendTo = {
                    name: payload.item.full_name,
                    number: payload.item.mobile ? payload.item.mobile : payload.item.parent ? payload.item.parent.mobile : null
                }
                this.rowID = payload.item.id

                this.SMSMeta = {
                    first: payload.item.first,
                    last: payload.item.last,
                }

                this.showSMSModal = true;
            },
            methodHandler: function(method){
                this[method]();
            },
            exportData: function(){
                this.$store.commit('TOGGLE_BACKDROP', { open: true });

                axios.get(process.env.VUE_APP_API_URL + '/export/'+this.resource).then(response => {
                    this.$store.commit('TOGGLE_BACKDROP', { open: false });
                    this.$notify({
                        group: 'main',
                        type: 'success',
                        title: 'Success',
                        text: 'You will receive an email within the few minutes',
                        duration: 5000
                    });
                });
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/5',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);

            //Member ID Filter
            const memberIDFilter = {
                label: 'Member ID',
                name: 'member_id',
                type: 'text',
                width: 'w-1/5',
                value: this.memberIdValue,
                placeholder: 'Search...'
            };

            this.filters.push(memberIDFilter);

            // Member Types Filter
            const memberTypesFilter = {
                label: 'Member Type',
                name: 'type',
                type: 'select',
                options: this.$store.getters.memberTypes.map(function (memberType) {
                    return {label: memberType.name, value: memberType.id};
                }),
                width: 'w-1/5',
                value: this.memberTypeValue,
                placeholder: 'Member Type...'
            };

            if (this.$store.getters.memberTypes.length === 0){
                this.$store.dispatch('GET_MEMBER_TYPES').then(() => {
                    memberTypesFilter.options = this.$store.getters.memberTypes.map(function (type) {
                        return { label: type.name, value: type.id };
                    });
                    memberTypesFilter.value = this.memberTypeValue;
                    this.filters.push(memberTypesFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(memberTypesFilter);
            }

            //Search Filter
            const dobFilter = {
                label: 'Date of Birth',
                name: 'dob',
                type: 'text-mask',
                mask: '##/##/####',
                width: 'w-1/5',
                value: this.dobValue,
                placeholder: 'DD/MM/YYYY'
            };

            this.filters.push(dobFilter);

            // Member Types Filter
            const memberStatusFilter = {
                label: 'Status',
                name: 'status',
                type: 'select',
                options: [
                    {label: 'Active', value: 'true'},
                    {label: 'Inactive', value: 'false'}
                ],
                width: 'w-1/5',
                value: this.statusValue,
                placeholder: 'Status...'
            };

            this.filters.push(memberStatusFilter);

            this.pageActions = {
                buttons: [
                    {
                        label: 'New Member',
                        icon: 'plus',
                        type: 'router-link',
                        link: '/members/create',
                        display: this.$store.getters.permissions.indexOf('members.create') !== -1,
                        iconClass: 'text-green-600'
                    },
                    {
                        label: 'Export',
                        icon: 'download',
                        type: 'method',
                        method: 'exportData',
                        display: this.$store.getters.permissions.indexOf('members.create') !== -1,
                        iconClass: 'text-gray-800'
                    },
                    {
                        label: 'Import',
                        icon: 'upload',
                        type: 'router-link',
                        link: '/members/import',
                        display: this.$store.getters.permissions.indexOf('members.create') !== -1,
                        iconClass: 'text-default-500'
                    }
                ],
                additional: []
            }
        },
        computed: {
            memberTypeValue(){
                const filters = this.$store.getters.filters;
                if (filters.members.type){
                    return filters.members.type;
                } else {
                    return null;
                }
            },
            statusValue () {
                const filters = this.$store.getters.filters;

                if (filters.members.search && filters.members.search.status){
                    return filters.members.search.status;
                } else {
                    return '';
                }
            },
            searchValue () {
                const filters = this.$store.getters.filters;

                if (filters.members.search){
                    return filters.members.search.value;
                } else {
                    return '';
                }
            },
            memberIdValue () {
                const filters = this.$store.getters.filters;

                if (filters.members.member_id){
                    return filters.members.member_id.value;
                } else {
                    return '';
                }
            },
            dobValue () {
                const filters = this.$store.getters.filters;

                if (filters.members.dob){
                    return filters.members.dob.value;
                } else {
                    return '';
                }
            }
        }
    }
</script>

<style scoped>

</style>
